import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
    FilledCard,
    Flex,
    Heading2,
    Stack,
    TextButton,
} from '@myphx-engineering/phx-design-system';
import { CoverageCard } from '@phx/myphx-lib';

import { getFragment } from '../../../graphql';
import { isDisplayablePlan } from '../../../graphql/policies/util';
import { getAbsoluteRoute } from '../../../util';
import { mapPlanData } from '../../../util/offers/get-offer-plan-data';
import { CobrandedLogo } from '../../cobranding/CobrandedLogo';
import { ConditionalComponent } from '../../utility/ConditionalComponent';
import type { OrderConfirmationProps } from '../OrderConfirmation';

export const ShareWithPharmacy = ({
    offer,
    prescriberOrder,
}: OrderConfirmationProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const patient = getFragment(prescriberOrder.patient);
    const offerPlanData = isDisplayablePlan(offer.plan)
        ? [
              mapPlanData(
                  offer.plan,
                  patient.fullName,
                  patient.coveragesConnection.edges
              ),
          ]
        : [];

    return (
        <ConditionalComponent condition={!!offer}>
            <FilledCard>
                <Stack gap="sm">
                    <Flex justify="space-between" align="center">
                        <Heading2>
                            {t('orderConfirmation.coverageCard.subHeader')}
                        </Heading2>
                        <TextButton
                            onClick={() =>
                                navigate(getAbsoluteRoute('profile.benefit'))
                            }
                        >
                            {t('orderConfirmation.coverageCard.viewDetails')}
                        </TextButton>
                    </Flex>
                    {offerPlanData && (
                        <CoverageCard
                            {...offerPlanData[0]}
                            partnerLogo={<CobrandedLogo />}
                        />
                    )}
                </Stack>
            </FilledCard>
        </ConditionalComponent>
    );
};
